module.exports = __webpack_public_path__ + "static/media/doctorfinding.c2532ac3.png";